import { LangCode } from "@/lib/gql/__generated__/graphql";

import { FeatureIslandMainWithCategoryWrapper } from "@/components/features/_layouts";

import { ForCheckInEmailTemplates } from "./for-check-in";
import { ForCheckOutEmailTemplates } from "./for-check-out";
import { ForTriggerReservationEmailTemplates } from "./for-trigger-reservation/email-templates";
import { usePlanEmailTemplates } from "./hooks";

import type { PlanCategoriesAndManagerStore } from "../../../store/categories";

type Props = {
	email: PlanCategoriesAndManagerStore["email"];
};

export const QuestionPlanEmailTemplates = ({ email }: Props) => {
	const {
		isEdited,
		hasError,
		// 予約確定
		atCreated,
		onSetAtCreatedForText,
		onSetAtCreatedForOverride,
		// 予約変更
		atUpdated,
		onSetAtUpdatedForText,
		onSetAtUpdatedForOverride,
		// 予約キャンセル
		atCanceled,
		onSetAtCanceledForText,
		onSetAtCanceledForOverride,
		// チェックイン7日前
		atCheckInBefore_07days,
		onSetAtCheckInBefore_07daysForText,
		onSetAtCheckInBefore_07daysForOverride,
		onSetAtCheckInBefore_07daysForShouldSendMail,
		// チェックイン1日前
		atCheckInBefore_01days,
		onSetAtCheckInBefore_01daysForText,
		onSetAtCheckInBefore_01daysForOverride,
		onSetAtCheckInBefore_01daysForShouldSendMail,
		// チェックイン当日
		atCheckInBefore_00days,
		onSetAtCheckInBefore_00daysForText,
		onSetAtCheckInBefore_00daysForOverride,
		onSetAtCheckInBefore_00daysForShouldSendMail,
		// チェックアウト1日後
		atCheckOutAfter_01days,
		onSetAtCheckOutAfter_01daysForText,
		onSetAtCheckOutAfter_01daysForOverride,
		onSetAtCheckOutAfter_01daysForShouldSendMail,
		// テストメール送信
		handleClickedSendTestEmailReservationCanceled,
		handleClickedSendTestEmailReservationCreated,
		handleClickedSendTestEmailReservationUpdated,
		handleClickedSendTestEmailReservationAtCheckInBefore_00days,
		handleClickedSendTestEmailReservationAtCheckInBefore_01days,
		handleClickedSendTestEmailReservationAtCheckInBefore_07days,
		handleClickedSendTestEmailReservationAtCheckOutAfter_01days,
		// ホテルメールアドレス
		hotelEmailAddress,
		// 基本メール設定
		basicCustomMailSetting,
	} = usePlanEmailTemplates();
	return (
		<>
			{/* 予約確定・変更・キャンセル時 */}
			<FeatureIslandMainWithCategoryWrapper
				categoryStore={email}
				islandTitle="予約：確定・変更・キャンセルメールの内容設定"
				tooltipTitle="ゲストに送信されるメールの内容をカスタマイズできます。<br /> 「テスト送信」ボタンからテスト送信ができ、実際に確認できます。"
			>
				<ForTriggerReservationEmailTemplates
					lang={LangCode.Default}
					isEdited={isEdited}
					hasError={hasError}
					atCreated={atCreated}
					onSetAtCreatedForText={onSetAtCreatedForText}
					onSetAtCreatedForOverride={onSetAtCreatedForOverride}
					atUpdated={atUpdated}
					onSetAtUpdatedForText={onSetAtUpdatedForText}
					onSetAtUpdatedForOverride={onSetAtUpdatedForOverride}
					atCanceled={atCanceled}
					onSetAtCanceledForText={onSetAtCanceledForText}
					onSetAtCanceledForOverride={onSetAtCanceledForOverride}
					hotelEmailAddress={hotelEmailAddress}
					handleClickedSendTestEmailReservationCanceled={handleClickedSendTestEmailReservationCanceled}
					handleClickedSendTestEmailReservationCreated={handleClickedSendTestEmailReservationCreated}
					handleClickedSendTestEmailReservationUpdated={handleClickedSendTestEmailReservationUpdated}
					basicCustomMailSetting={basicCustomMailSetting}
				/>
			</FeatureIslandMainWithCategoryWrapper>
			{/* チェックイン前 */}
			<FeatureIslandMainWithCategoryWrapper
				categoryStore={email}
				islandTitle="チェックイン前：リマインドの内容設定"
				tooltipTitle="チェックイン前にゲストに送信されるメールの内容をカスタマイズできます。<br /> 「テスト送信」ボタンからテスト送信ができ、実際に確認できます。"
			>
				<ForCheckInEmailTemplates
					lang={LangCode.Default}
					isEdited={isEdited}
					hasError={hasError}
					atCheckInBefore_07days={atCheckInBefore_07days}
					onSetAtCheckInBefore_07daysForText={onSetAtCheckInBefore_07daysForText}
					onSetAtCheckInBefore_07daysForOverride={onSetAtCheckInBefore_07daysForOverride}
					onSetAtCheckInBefore_07daysForShouldSendMail={onSetAtCheckInBefore_07daysForShouldSendMail}
					onSetAtCheckInBefore_01daysForText={onSetAtCheckInBefore_01daysForText}
					onSetAtCheckInBefore_01daysForOverride={onSetAtCheckInBefore_01daysForOverride}
					onSetAtCheckInBefore_01daysForShouldSendMail={onSetAtCheckInBefore_01daysForShouldSendMail}
					atCheckInBefore_00days={atCheckInBefore_00days}
					onSetAtCheckInBefore_00daysForText={onSetAtCheckInBefore_00daysForText}
					onSetAtCheckInBefore_00daysForOverride={onSetAtCheckInBefore_00daysForOverride}
					onSetAtCheckInBefore_00daysForShouldSendMail={onSetAtCheckInBefore_00daysForShouldSendMail}
					atCheckInBefore_01days={atCheckInBefore_01days}
					hotelEmailAddress={hotelEmailAddress}
					handleClickedSendTestEmailReservationAtCheckInBefore_00days={
						handleClickedSendTestEmailReservationAtCheckInBefore_00days
					}
					handleClickedSendTestEmailReservationAtCheckInBefore_01days={
						handleClickedSendTestEmailReservationAtCheckInBefore_01days
					}
					handleClickedSendTestEmailReservationAtCheckInBefore_07days={
						handleClickedSendTestEmailReservationAtCheckInBefore_07days
					}
					basicCustomMailSetting={basicCustomMailSetting}
				/>
			</FeatureIslandMainWithCategoryWrapper>
			{/* チェックアウト後 */}
			<FeatureIslandMainWithCategoryWrapper
				categoryStore={email}
				islandTitle="チェックアウト後：ご案内メール設定"
				tooltipTitle="チェックアウト後にゲストに送信されるメールの内容をカスタマイズできます。<br /> 「テスト送信」ボタンからテスト送信ができ、実際に確認できます。"
			>
				<ForCheckOutEmailTemplates
					lang={LangCode.Default}
					isEdited={isEdited}
					hasError={hasError}
					atCheckOutAfter_01days={atCheckOutAfter_01days}
					onSetAtCheckOutAfter_01daysForText={onSetAtCheckOutAfter_01daysForText}
					onSetAtCheckOutAfter_01daysForOverride={onSetAtCheckOutAfter_01daysForOverride}
					onSetAtCheckOutAfter_01daysForShouldSendMail={onSetAtCheckOutAfter_01daysForShouldSendMail}
					hotelEmailAddress={hotelEmailAddress}
					handleClickedSendTestEmailReservationAtCheckOutAfter_01days={
						handleClickedSendTestEmailReservationAtCheckOutAfter_01days
					}
					basicCustomMailSetting={basicCustomMailSetting}
				/>
			</FeatureIslandMainWithCategoryWrapper>
		</>
	);
};

QuestionPlanEmailTemplates.displayName = "QuestionPlanEmailTemplates";
